import React, { useState, useEffect, useRef } from 'react';
import emailjs from "emailjs-com";
import styles from '../Styles/LandingPage.module.scss';
import logo from "../Images/logo.png"
import banner from "../Images/banner.jpg"
import calendar from "../Images/icons/icons8-calendar-100.png"
import phone from "../Images/icons/icons8-iphone-100.png"
import pro from "../Images/icons/icons8-engineer-64.png"
import why1 from "../Images/icons/icons8-settings-100.png"
import why2 from "../Images/icons/icons8-delivery-100.png"
import why3 from "../Images/icons/icons8-warranty-64.png"
import why4 from "../Images/icons/icons8-expert-user-66.png"


const HomePage = () => {
    const items = [
        {
            id: 1,
            q: "Do you use genuine parts for service?",
            a: "Yes, we prioritize using genuine parts for service to ensure the highest quality and compatibility.",
        },
        {
            id: 2,
            q: "Is there a warranty on your service?",
            a: "Yes, we provide a warranty of 3-12 months for our services.",
        },
        {
            id: 3,
            q: "What is the mode of payment you accept for services?",
            a: "We accept various modes like cash, Debit & Credit cards, wallet, or UPI",
        },
        {
            id: 4,
            q: "Is it necessary to back up my Data before bringing it in for service?",
            a: "It's always a good idea to back up your Data before any service. Although we take utmost care during the service process, backing up your device ensures the safety of your data. We can also assist you with data backup if needed.",
        },
    ];

    const [openId, setOpenId] = useState(null);

    const toggle = (id) => {
        setOpenId((prev) => (prev === id ? null : id));
    };

    const [scrolled, setScrolled] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 50) {
                setScrolled(true);
            } else {
                setScrolled(false);
            }
        };

        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    const [selectedDevice, setSelectedDevice] = useState("");
    const [selectedModel, setSelectedModel] = useState("");
    const [issue, setIssue] = useState("");
    const [formData, setFormData] = useState({ name: "", number: "", email: "" });
    const [errors, setErrors] = useState({});
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [submitSuccess, setSubmitSuccess] = useState(null); // null / true / false
    const formRef = useRef(null);


    // Device → Models mapping
    const deviceModels = {
        iPhone: [
            "iPhone 17 ",
            "iPhone 17 Air",
            "iPhone 17 Pro ",
            "iPhone 16 Pro Max",
            "iPhone 16 Pro",
            "iPhone 16",
            "iPhone 16 Plus",
            "iPhone 15 Pro Max",
            "iPhone 15 Pro",
            "iPhone 15",
            "iPhone 15 Plus",
            "iPhone 14 Pro Max",
            "iPhone 14 Pro",
            "iPhone 14",
            "iPhone 14 Plus",
            "iPhone 13 Pro Max",
            "iPhone 13 Pro",
            "iPhone 13",
            "iPhone 13 Mini",
            "iPhone 12 Mini",
            "iPhone 12",
            "iPhone 12 Pro",
            "iPhone 12 Pro Max",
            "iPhone 11 Pro",
            "iPhone 11 Pro Max",
            "iPhone SE (3rd generation)",
            "iPhone SE (2nd generation)",
            "iPhone SE (1st generation)",
            "iPhone 11",
            "iPhone XR",
            "iPhone XS Max",
            "iPhone XS",
            "iPhone X",
            "iPhone 8 Plus",
            "iPhone 8",
            "iPhone 7 Plus",
            "iPhone 7",
            "iPhone SE",
            "iPhone 6s Plus",
            "iPhone 6s",
            "iPhone 6 Plus",
            "iPhone 6",
            "iPhone 5S",
            "iPhone 5C",
            "iPhone 5",
            "iPhone 4",
            "iPhone 3GS",
            "iPhone 3G",
            "Other"
        ],
        Macbook: [
            "MacBook Air 13\" (M3)",
            "MacBook Air 13\" (M2)",
            "MacBook Air 15\" (M3)",
            "MacBook Pro 14\" (M3)",
            "MacBook Pro 14\" (M3 Pro)",
            "MacBook Pro 14\" (M3 Max)",
            "MacBook Pro 16\" (M3 Pro)",
            "MacBook Pro 16\" (M3 Max)",
            "MacBook Air 15\" (M2, 2023)",
            "MacBook Air 13\" (M1, 2020)",
            "MacBook Air (Intel, 2020)",
            "MacBook Air (Intel, 2017)",
            "MacBook Pro 13\" (M2, 2022)",
            "MacBook Pro 13\" (M1, 2020)",
            "MacBook Pro 13\" (Intel, two ports, 2020)",
            "MacBook Pro 13\" (Intel, four ports, 2020)",
            "MacBook Pro 14\" (M2 Pro, 2023)",
            "MacBook Pro 14\" (M2 Max, 2023)",
            "MacBook Pro 14\" (M1 Pro, 2021)",
            "MacBook Pro 14\" (M1 Max, 2021)",
            "MacBook Pro 16\" (M2 Pro, 2023)",
            "MacBook Pro 16\" (M2 Max, 2023)",
            "MacBook Pro 16\" (M1 Pro, 2021)",
            "MacBook Pro 16\" (M1 Max, 2021)",
            "MacBook Pro 16\" (Intel, 2019)",
            "MacBook Pro 14-in. (2021)",
            "MacBook Pro 16-in. (2021)",
            "MacBook Air (M1, 2020)",
            "MacBook Air (Retina, 2020)",
            "MacBook Air (2017)",
            "MacBook Pro 13-in. (M1, 2020)",
            "MacBook Pro 13-in. (Two Thunderbolt 3 ports, 2016)",
            "MacBook Pro 13-in. (Four Thunderbolt 3 ports, 2020)",
            "MacBook Pro 16-in. (2019)",
            "Other"
        ],
        iPad: [
            "iPad Pro 13\" (M4)",
            "iPad Pro 11\" (M4)",
            "iPad Air 13\" (M2)",
            "iPad Air 11\" (M2)",
            "iPad (10th generation)",
            "iPad mini (6th generation)",
            "iPad Pro 12.9\" (6th generation)",
            "iPad Pro 12.9\" (5th generation)",
            "iPad Pro 12.9\" (4th generation)",
            "iPad Pro 12.9\" (3rd generation)",
            "iPad Pro 12.9\" (2nd generation)",
            "iPad Pro 12.9\" (1st generation)",
            "iPad Pro 11\" (4th generation)",
            "iPad Pro 11\" (3rd generation)",
            "iPad Pro 11\" (2nd generation)",
            "iPad Pro 11\" (1st generation)",
            "iPad Pro 10.5\"",
            "iPad Pro 9.7\"",
            "iPad Air (5th generation)",
            "iPad Air (4th generation)",
            "iPad Air (3rd generation)",
            "iPad Air (1st generation)",
            "iPad Air 2",
            "iPad (1st generation)",
            "iPad (9th generation)",
            "iPad (8th generation)",
            "iPad (7th generation)",
            "iPad (6th generation)",
            "iPad (5th generation)",
            "iPad mini (5th generation)",
            "iPad mini 4",
            "iPad mini 3",
            "iPad mini 2",
            "iPad 1",
            "iPad 2",
            "iPad 3",
            "iPad 4",
            "iPad 5",
            "iPad 6",
            "iPad 7",
            "iPad Mini",
            "Other"
        ],
        iWatch: [
            "Apple Watch Series 10 42mm",
            "Apple Watch Series 10 46mm",
            "Apple Watch Ultra 2 49mm",
            "Apple Watch Series 9 41mm",
            "Apple Watch Series 9 45mm",
            "Apple Watch Series 8 45mm",
            "Apple Watch Series 8 41mm",
            "Apple Watch Ultra 1 49mm",
            "Apple Watch Series 7 41mm",
            "Apple Watch Series 7 45mm",
            "Apple Watch Series 6 40mm",
            "Apple Watch Series 6 44mm",
            "Apple Watch SE 40mm (1st generation)",
            "Apple Watch SE 44mm (1st generation)",
            "Apple Watch Series 5 40mm",
            "Apple Watch Series 5 44mm",
            "Apple Watch Series 4 40mm",
            "Apple Watch Series 4 44mm",
            "Apple Watch Series 3 38mm",
            "Apple Watch Series 3 42mm",
            "Apple Watch Series 2 38mm",
            "Apple Watch Series 2 42mm",
            "Apple Watch Series 1 38mm",
            "Apple Watch Series 1 42mm",
            "Other"
        ],
        iMac: [
            "iMac M3 24inch",
            "iMac M1 24inch",
            "iMac Pro",
            "iMac with Retina 5K display 27inch",
            "iMac with Retina 4K display 24inch",
            "iMac 27inch",
            "iMac 21.5inch"
        ]

    };

    const handleDeviceChange = (e) => {
        setSelectedDevice(e.target.value);
        setSelectedModel(""); // reset model when device changes
    };



    useEffect(() => {
        // Optional: init with your public key if your emailjs version requires it
        // emailjs.init("YOUR_PUBLIC_KEY");
    }, []);

    // single-field validator
    const validateField = (field, value) => {
        let err = "";
        if (field === "name") {
            if (!value.trim()) err = "Name is required";
        } else if (field === "email") {
            if (!value.trim()) err = "Email is required";
            else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) err = "Invalid email format";
        } else if (field === "number") {
            if (!value.trim()) err = "Mobile number is required";
            else if (!/^[0-9]{10}$/.test(value)) err = "Enter a valid 10-digit number";
        } else if (field === "device") {
            if (!value) err = "Please select a device";
        } else if (field === "model") {
            if (!value) err = "Please select a model";
        } else if (field === "issue") {
            if (!value) err = "Please select an issue";
        }

        setErrors(prev => ({ ...prev, [field]: err }));
        return err === "";
    };

    // validate all fields before submit
    const validateForm = () => {
        const checks = [
            validateField("name", formData.name),
            validateField("email", formData.email),
            validateField("number", formData.number),
            validateField("device", selectedDevice),
            validateField("model", selectedModel),
            validateField("issue", issue),
        ];
        return checks.every(Boolean);
    };

    // handle changes for inputs & selects
    const handleChange = e => {
        const { name, value } = e.target;

        // allow only digits in mobile input
        if (name === "number") {
            if (!/^\d*$/.test(value)) return; // ignore non-digit input
        }

        if (name === "device") {
            setSelectedDevice(value);
            setSelectedModel(""); // reset model when device changes
            validateField("device", value);
            // clear model error immediately when device changes
            setErrors(prev => ({ ...prev, model: "" }));
            return;
        }

        if (name === "model") {
            setSelectedModel(value);
            validateField("model", value);
            return;
        }

        if (name === "issue") {
            setIssue(value);
            validateField("issue", value);
            return;
        }

        setFormData(prev => ({ ...prev, [name]: value }));
        validateField(name, value);
    };

    // submit handler
    const handleSubmit = async e => {
        e.preventDefault();
        setSubmitSuccess(null);

        if (!validateForm()) {
            console.log("Validation failed", errors);
            return;
        }

        setIsSubmitting(true);

        // Build template params (names here must match what your EmailJS template expects)
        const templateParams = {
            device: selectedDevice,
            model: selectedModel,
            issue,
            name: formData.name,
            number: formData.number,
            email: formData.email,
        };

        try {
            // Option A: using emailjs.send (templateParams)
            const response = await emailjs.send(
                "service_a53irum",
                "template_rpwgp7p",
                templateParams,
                "EAwqF14p6dB7TULQz"
                // optional 4th arg: "YOUR_PUBLIC_KEY" if your version needs it
            );
            console.log("EmailJS success:", response);
            setSubmitSuccess(true);
            // reset form (optional)
            setFormData({ name: "", number: "", email: "" });
            setSelectedDevice("");
            setSelectedModel("");
            setIssue("");
            setErrors({});
        } catch (err) {
            console.error("EmailJS error:", err);
            setSubmitSuccess(false);
        } finally {
            setIsSubmitting(false);
        }
    };

    // helpful small guard if deviceModels isn't provided
    const deviceKeys = Object.keys(deviceModels || {});


    return (
        <div className="homepage">
            <div className={styles.wrap}>
                <div className={styles.wrapBody}>

                    <header className={`${styles.header} ${scrolled ? styles.scrolled : ""}`}>

                        <img src={logo} alt="iConnectCare" className={styles.logo} />

                        <a href="tel:9001543859">Call Us:- +91 90015 43859</a>


                    </header>

                    <section className={styles.landing}>
                        <div className={styles.container}>
                            {/* Left Content */}
                            <div className={styles.text}>
                                <h1>
                                    FREE PICK & DROP  <br />
                                    SERVICE IN <span>GURGAON</span>
                                </h1>
                                <h2>WITHIN 30-45 MINUTES</h2>
                                <h3>
                                    <span>  One Mind Solutions </span>Is One-Stop Solution For All Your Requirements
                                </h3>

                                {/* <div className={styles.rating}>
                                    <p>
                                        Rated <span className={styles.highlight}>4.9+</span> ⭐ On Google By{" "}
                                        <span className={styles.highlight}>1000+</span> Customer Reviews
                                    </p>
                                </div>*/}

                                <button className={styles.ctaBtn}>Get Free Quote On Call</button>
                            </div>

                            {/* Right Form */}
                            <div className={styles.formWrap}>
                                <div className={styles.images}>
                                    <img src={banner} alt="MacBook" className={styles.macbook} />
                                </div>
                                <form ref={formRef} className={styles.form} onSubmit={handleSubmit} noValidate>
                                    <div className={styles.formRow}>
                                        <div style={{ display: "flex", flexDirection: "column", marginRight: 8 }}>
                                            <select
                                                name="device"
                                                value={selectedDevice}
                                                onChange={handleChange}
                                                style={errors.device ? { borderColor: "red" } : {}}
                                            >
                                                <option value="">Select Device</option>
                                                {deviceKeys.length === 0 ? (
                                                    <option value="">No devices</option>
                                                ) : (
                                                    deviceKeys.map(device => <option key={device} value={device}>{device}</option>)
                                                )}
                                            </select>
                                            {errors.device && <span className={styles.error}>{errors.device}</span>}
                                        </div>

                                        <div style={{ display: "flex", flexDirection: "column", marginRight: 8 }}>
                                            <select
                                                name="model"
                                                value={selectedModel}
                                                onChange={handleChange}
                                                disabled={!selectedDevice}
                                                style={errors.model ? { borderColor: "red" } : {}}
                                            >
                                                <option value="">Select Model</option>
                                                {selectedDevice &&
                                                    (deviceModels[selectedDevice] || []).map(m => (
                                                        <option key={m} value={m}>
                                                            {m}
                                                        </option>
                                                    ))}
                                            </select>
                                            {errors.model && <span className={styles.error}>{errors.model}</span>}
                                        </div>

                                        <div style={{ display: "flex", flexDirection: "column" }}>
                                            <select
                                                name="issue"
                                                value={issue}
                                                onChange={handleChange}
                                                style={errors.issue ? { borderColor: "red" } : {}}
                                            >
                                                <option value="">Select Issue</option>
                                                <option value="screen-damage">Screen Damage</option>
                                                <option value="battery-problem">Battery Problem</option>
                                                <option value="button-problem">Button Problem</option>
                                                <option value="water-damage">Water Damage</option>
                                                <option value="not-powering">Device Not Powering On</option>
                                                <option value="other">Other</option>
                                            </select>
                                            {errors.issue && <span className={styles.error}>{errors.issue}</span>}
                                        </div>
                                    </div>

                                    <div className={styles.formRow} style={{ marginTop: 12 }}>
                                        <div style={{ display: "flex", flexDirection: "column", marginRight: 8 }}>
                                            <input
                                                type="text"
                                                name="name"
                                                placeholder="Name"
                                                value={formData.name}
                                                onChange={handleChange}
                                                style={errors.name ? { borderColor: "red" } : {}}
                                            />
                                            {errors.name && <span className={styles.error}>{errors.name}</span>}
                                        </div>

                                        <div style={{ display: "flex", flexDirection: "column", marginRight: 8 }}>
                                            <input
                                                type="text"
                                                name="number"
                                                placeholder="Number"
                                                value={formData.number}
                                                onChange={handleChange}
                                                maxLength={10}
                                                style={errors.number ? { borderColor: "red" } : {}}
                                            />
                                            {errors.number && <span className={styles.error}>{errors.number}</span>}
                                        </div>

                                        <div style={{ display: "flex", flexDirection: "column" }}>
                                            <input
                                                type="email"
                                                name="email"
                                                placeholder="Email"
                                                value={formData.email}
                                                onChange={handleChange}
                                                style={errors.email ? { borderColor: "red" } : {}}
                                            />
                                            {errors.email && <span className={styles.error}>{errors.email}</span>}
                                        </div>
                                    </div>

                                    <div style={{ marginTop: 16 }}>
                                        <button type="submit" className={styles.submitBtn} disabled={isSubmitting}>
                                            {isSubmitting ? "Submitting..." : "Submit"}
                                        </button>
                                    </div>

                                    {submitSuccess === true && <p style={{ color: "green" }}>Form sent successfully.</p>}
                                    {submitSuccess === false && <p style={{ color: "red" }}>Failed to send form. Check console/network.</p>}
                                </form>

                            </div>
                        </div>

                        {/* Device Images */}

                    </section>
                </div>

                <section className={styles.how} aria-labelledby="how-it-works-title">
                    <h2 id="how-it-works-title" className={styles.title}>
                        How It <span>Works</span>
                    </h2>
                    <div className={styles.inner}>

                        <div className={styles.howwrap}>
                            <div className={styles.box}></div>
                            <div className={styles.box}></div>
                            <div className={styles.box}></div>
                            <div className={styles.box}></div>
                        </div>

                        {/* Right: steps */}
                        <div className={styles.steps}>
                            <div className={styles.step}>
                                <div className={styles.icon} aria-hidden="true">
                                    <img src={calendar} alt="calendar" />
                                </div>
                                <div className={styles.stepText}>
                                    <h3>Book an appointment</h3>
                                    <p>The appointment can be easily scheduled for the time and location of your choice.</p>
                                </div>
                            </div>

                            <div className={styles.step}>
                                <div className={styles.icon} aria-hidden="true">
                                    <img src={pro} alt="calendar" />

                                </div>
                                <div className={styles.stepText}>
                                    <h3>Our Professional visits you</h3>
                                    <p>Our qualified professional comes to your home or place where you work to fix your device in your presence.</p>
                                </div>
                            </div>

                            <div className={styles.step}>
                                <div className={styles.icon} aria-hidden="true">
                                    <img src={phone} alt="calendar" />

                                </div>
                                <div className={styles.stepText}>
                                    <h3>Get your phone good as new</h3>
                                    <p>Get your device back in perfect working order, as if it had never been damaged. We never compromise on quality.</p>
                                </div>
                            </div>
                        </div>

                    </div>
                </section>

                <section className={styles.whyWrap}>
                    <div className={styles.whyContainer}>
                        <h2 className={styles.whyTitle}>Why Choose Us?</h2>
                        <p className={styles.whySubtitle}>A Choice That Makes Difference</p>

                        <div className={styles.whyFeatures}>
                            {/* Feature 1 */}
                            <div className={styles.whyFeature}>
                                <div className={styles.whyIconWrap}>
                                    <span className={styles.whyNumber}>01</span>
                                    <img
                                        src={why1}
                                        alt="Free Onsite"
                                        className={styles.whyIcon}
                                    />
                                </div>
                                <h3 className={styles.whyHeading}>Free Onsite</h3>
                                <p className={styles.whyText}>Get Doorstep Service in 30-45 Mins</p>
                            </div>

                            {/* Feature 2 */}
                            <div className={styles.whyFeature}>
                                <div className={styles.whyIconWrap}>
                                    <span className={styles.whyNumber}>02</span>
                                    <img
                                        src={why2}
                                        alt="Free Pickup & Drop"
                                        className={styles.whyIcon}
                                    />
                                </div>
                                <h3 className={styles.whyHeading}>Free Pickup & Drop</h3>
                                <p className={styles.whyText}>Schedule Pickup & Drop At Your Convenience</p>
                            </div>

                            {/* Feature 3 */}
                            <div className={styles.whyFeature}>
                                <div className={styles.whyIconWrap}>
                                    <span className={styles.whyNumber}>03</span>
                                    <img
                                        src={why3}
                                        alt="Warranty"
                                        className={styles.whyIcon}
                                    />
                                </div>
                                <h3 className={styles.whyHeading}>Warranty</h3>
                                <p className={styles.whyText}>3-12 Months Of Warranty</p>
                            </div>

                            {/* Feature 4 */}
                            <div className={styles.whyFeature}>
                                <div className={styles.whyIconWrap}>
                                    <span className={styles.whyNumber}>04</span>
                                    <img
                                        src={why4}
                                        alt="Expert Professionals"
                                        className={styles.whyIcon}
                                    />
                                </div>
                                <h3 className={styles.whyHeading}>Expert Professionals</h3>
                                <p className={styles.whyText}>
                                    Our Professionals Have 16+ Years Of Experience
                                </p>
                            </div>
                        </div>
                    </div>
                </section>

                <section className={styles.aboutWrap}>
                    <div className={styles.aboutContent}>
                        <div className={styles.aboutTextBox}>
                            <h2 className={styles.aboutHeading}>
                                About <span>Us</span>
                            </h2>
                            <p>
                                At Our One Mind Solutions, we are passionate about bringing
                                life back to your beloved devices. With a team of highly skilled
                                professionals, we specialize in providing reliable and efficient
                                services for a wide range of gadgets. From diagnosing and fixing
                                hardware issues to troubleshooting software glitches, we are
                                dedicated to restoring your gadgets to their optimal performance.
                                Trust us to deliver exceptional service and get your device back in
                                your hands in no time.
                            </p>
                        </div>

                        <div className={styles.aboutImageBox}>
                            <img
                                src={banner}
                                alt="About Devices"
                                className={styles.aboutImage}
                            />
                        </div>
                    </div>
                </section>

                <section className={styles.whyFaqWrap}>
                    <div className={styles.whyFaqContainer}>
                        <p className={styles.whySmallTitle}>MOST FREQUENT QUESTIONS AND ANSWERS</p>
                        <h2 className={styles.whyMainTitle}>FREQUENTLY ASKED QUESTION?</h2>

                        <div className={styles.whyGrid}>
                            {/* left column: first two (or 2 items) */}
                            <div className={styles.whyCol}>
                                {items.slice(0, 2).map((it) => (
                                    <article
                                        key={it.id}
                                        className={`${styles.whyStep} ${openId === it.id ? styles.whyStepOpen : ""
                                            }`}
                                    >
                                        <button
                                            className={styles.whyStepBtn}
                                            onClick={() => toggle(it.id)}
                                            aria-expanded={openId === it.id}
                                            aria-controls={`why-panel-${it.id}`}
                                        >
                                            <span className={styles.whyQ}>{it.q}</span>
                                            <span
                                                className={`${styles.whyIcon} ${openId === it.id ? styles.whyIconOpen : ""
                                                    }`}
                                                aria-hidden="true"
                                            >
                                                ▾
                                            </span>
                                        </button>

                                        <div
                                            id={`why-panel-${it.id}`}
                                            className={styles.whyPanel}
                                            role="region"
                                            aria-labelledby={`why-btn-${it.id}`}
                                            style={{
                                                maxHeight: openId === it.id ? "500px" : "0px",
                                                padding: openId === it.id ? "20px 28px" : "0 28px",
                                            }}
                                        >
                                            <p className={styles.whyA}>{it.a}</p>
                                        </div>
                                    </article>
                                ))}
                            </div>

                            {/* right column: last two */}
                            <div className={styles.whyCol}>
                                {items.slice(2).map((it) => (
                                    <article
                                        key={it.id}
                                        className={`${styles.whyStep} ${openId === it.id ? styles.whyStepOpen : ""
                                            }`}
                                    >
                                        <button
                                            className={styles.whyStepBtn}
                                            onClick={() => toggle(it.id)}
                                            aria-expanded={openId === it.id}
                                            aria-controls={`why-panel-${it.id}`}
                                            id={`why-btn-${it.id}`}
                                        >
                                            <span className={styles.whyQ}>{it.q}</span>
                                            <span
                                                className={`${styles.whyIcon} ${openId === it.id ? styles.whyIconOpen : ""
                                                    }`}
                                                aria-hidden="true"
                                            >
                                                ▾
                                            </span>
                                        </button>

                                        <div
                                            id={`why-panel-${it.id}`}
                                            className={styles.whyPanel}
                                            role="region"
                                            aria-labelledby={`why-btn-${it.id}`}
                                            style={{
                                                maxHeight: openId === it.id ? "500px" : "0px",
                                                padding: openId === it.id ? "20px 28px" : "0 28px",
                                            }}
                                        >
                                            <p className={styles.whyA}>{it.a}</p>
                                        </div>
                                    </article>
                                ))}
                            </div>
                        </div>
                    </div>
                </section>


                <section className={styles.contactWrap}>
                    <div className={styles.contactInner}>
                        <h2 className={styles.contactMainTitle}>Still Not Convinced?</h2>
                        <p className={styles.contactSubtitle}>
                            Fill The Form Below, And Our Team Will Contact You
                        </p>

                        <div className={styles.contactGrid}>
                            {/* Left card with contact info */}
                            <aside className={styles.contactCard} aria-label="Contact Information">
                                <div className={styles.contactCardInner}>
                                    <h3 className={styles.contactCardTitle}>Contact Information</h3>

                                    <div className={styles.contactInfo}>
                                        <div className={styles.contactIcon}>📍</div>
                                        <div>
                                            <h4 className={styles.contactLabel}>Address</h4>
                                            <p className={styles.contactText}>
                                                Plot No. 3942/1, Rajendra Park, Gurgaon - 122017, Haryana
                                            </p>
                                        </div>
                                    </div>

                                    <div className={styles.contactInfo}>
                                        <div className={styles.contactIcon}>📞</div>
                                        <div>
                                            <h4 className={styles.contactLabel}>Phone No</h4>
                                            <p className={styles.contactText}>+91 90015 43859</p>
                                        </div>
                                    </div>

                                    <div className={styles.contactInfo}>
                                        <div className={styles.contactIcon}>✉️</div>
                                        <div>
                                            <h4 className={styles.contactLabel}>Email Id</h4>
                                            <p className={styles.contactText}>
                                                sales@1mind.in
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </aside>

                            {/* Right: form */}
                            <form className={styles.contactForm} onSubmit={(e) => e.preventDefault()}>
                                <div className={styles.row}>
                                    <label className={styles.fieldLabel}>Name</label>
                                    <input className={styles.field} placeholder="Your Name" />
                                </div>

                                <div className={styles.rowTwo}>
                                    <div className={styles.col}>
                                        <label className={styles.fieldLabel}>Phone Number</label>
                                        <input className={styles.field} placeholder="Your Phone Number" />
                                    </div>

                                    <div className={styles.col}>
                                        <label className={styles.fieldLabel}>Email Address</label>
                                        <input className={styles.field} placeholder="Your Email Address" />
                                    </div>
                                </div>

                                <div className={styles.row}>
                                    <label className={styles.fieldLabel}>Select Device</label>
                                    <select className={styles.field} value={selectedDevice} onChange={handleDeviceChange}>
                                        <option value="">Select Device</option>
                                        {Object.keys(deviceModels).map((device) => (
                                            <option key={device} value={device}>
                                                {device}
                                            </option>
                                        ))}
                                    </select>
                                </div>

                                <div className={styles.row}>
                                    <label className={styles.fieldLabel}>Select Model</label>
                                    <select
                                        value={selectedModel}
                                        onChange={(e) => setSelectedModel(e.target.value)}
                                        disabled={!selectedDevice}
                                        className={styles.field}
                                    >
                                        <option value="">Select Model</option>
                                        {selectedDevice &&
                                            deviceModels[selectedDevice].map((model) => (
                                                <option key={model} value={model}>
                                                    {model}
                                                </option>
                                            ))}
                                    </select>
                                </div>

                                <div className={styles.row}>
                                    <label className={styles.fieldLabel}>Select Issue</label>

                                    <select name="issue" id="issue" className={styles.field}>
                                        <option value="issue">Issue</option>
                                        <option value="screen-damage">Screen Damage</option>
                                        <option value="battery-problem">Battery Problem</option>
                                        <option value="button-problem">Button Problem</option>
                                        <option value="water-damage">Water Damage</option>
                                        <option value="not-powering">Device Not Powering On</option>
                                        <option value="other">Other</option>
                                    </select>
                                </div>

                                <div className={styles.formFooter}>
                                    <button className={styles.submitBtn} type="submit">Submit</button>
                                </div>
                            </form>
                        </div>
                    </div>
                </section>
                <footer className={styles.footer}>
                    <p>
                        © {new Date().getFullYear()} One Mind Solutions | Designed, Developed & Marketed by Aptale Designs
                    </p>
                    <p className={styles.disclaimer}>
                        One Mind Solutions is an independent Apple product service provider. Apple product names, logos, and images are owned by Apple Inc., and we have no affiliation or endorsement from Apple Inc.
                    </p>
                </footer>
            </div>
        </div>
    );
};

export default HomePage;
